import React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import { getDocumentDownloadUrl } from "../../store/actions/documentActions";

interface Props {
    open: boolean;
    onClose: () => void;
    document: iPersonDocument | null;
}

const DocumentPreviewDialog = (props: Props) => {
    const { document } = props;
    if (!document) return null;

    const token = localStorage.getItem('token-id');
    const fileUrl = document.fileName
        ? getDocumentDownloadUrl(document.fileName) + (token ? `?access_token=${token}` : '')
        : '';

    const isImage = document.mimeType?.startsWith('image/');
    const isPdf = document.mimeType === 'application/pdf';

    return (
        <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                {document.originalName || document.fileName}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: 300 }}>
                    {isImage && (
                        <img
                            src={fileUrl}
                            alt={document.originalName}
                            style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
                        />
                    )}
                    {isPdf && (
                        <iframe
                            src={fileUrl}
                            title={document.originalName}
                            width="100%"
                            height="500px"
                            style={{ border: 'none' }}
                        />
                    )}
                    {!isImage && !isPdf && (
                        <Typography color="text.secondary" sx={{ mt: 4 }}>
                            Visualização não disponível para este tipo de arquivo.
                        </Typography>
                    )}
                </Box>

                <Box sx={{ mt: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Tipo: {document.documentType?.name || '-'} |
                        Tamanho: {document.fileSize ? (document.fileSize / 1024).toFixed(1) + ' KB' : '-'} |
                        Upload: {document.uploadDate ? new Date(document.uploadDate).toLocaleDateString('pt-BR') : '-'}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DocumentPreviewDialog;
